
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class MenuUpdateAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "MenuUpdate";   
    super(baseUrl);
  }


  saveMenuUpdateSave(request: MenuUpdateRequest){
    
    return this.post("", request, false);
   
  }

}
export default new MenuUpdateAPI();

class MenuUpdateRequest {
   public siralarXml : string;
   constructor(siralarXml: string) {
         this.siralarXml = siralarXml;
    }
}
export { MenuUpdateRequest };
